import React from "react";
import k8sIcon from "../img/kubernetes.svg";
import { Address6 } from "ip-address";
import { jwtDecode } from "jwt-decode";
import { onError} from "@apollo/client/link/error";
import { appf_tenant_info, poolData } from "../UserPool";
import { closeSnackbar } from "notistack";
import { Button } from "@mui/material";
import CloseIcon from "../asset/misc/Close";

export const APPFACTOR = {
  command: "appf:command",
  __DEFAULT_PORT: 10042,
  __DEFAULT_WS_URL: "ws://localhost",
  __AEXP: "AppExtractProgress",
  __AEX: "AppExtractRequest",
  __ASCAN: "ScanRequest",
  __PRES: "ProtocolsResponse",
  tenantInfo: {},
  appName: "AppFactor",
  gTHREE: {}
};


export const AWSDeployStatesDetails = {
  PROVISIONING: "Amazon ECS has to perform additional steps before the task is launched. For example, for tasks that use the awsvpc network mode, the elastic network interface needs to be provisioned.",
  PENDING: "This is a transition state where Amazon ECS is waiting on the container agent to take further action. A task stays in the pending state until there are available resources for the task.",
  ACTIVATING: "This is a transition state where Amazon ECS has to perform additional steps after the task is launched but before the task can transition to the RUNNING state. For example, for tasks that have service discovery configured, the service discovery resources must be created. For tasks that are part of a service that's configured to use multiple Elastic Load Balancing target groups, the target group registration occurs during this state.",
  RUNNING: "The task is successfully running.",
  DEACTIVATING: "This is a transition state where Amazon ECS has to perform additional steps before the task is stopped. For example, for tasks that are part of a service that's configured to use multiple Elastic Load Balancing target groups, the target group deregistration occurs during this state.",
  STOPPING: "This is a transition state where Amazon ECS is waiting on the container agent to take further action.For Linux containers, the container agent will send the SIGTERM signal to notify the application needs to finish and shut down, and then the sends a SIGKILL after waiting the StopTimeout duration set in the task definition.",
  DEPROVISIONING: "Amazon ECS has to perform additional steps after the task has stopped but before the task transitions to the STOPPED state. For example, for tasks that use the awsvpc network mode, the elastic network interface needs to be detached and deleted.",
  STOPPED: "The task has been successfully stopped.",
  DELETED: "This is a transition state when a task stops."
};

export const AWSDeployStatesBREAK = {
  PROVISIONING: false,
  PENDING: false,
  ACTIVATING: false,
  RUNNING: true,
  DEACTIVATING: true,
  STOPPING: true,
  DEPROVISIONING: true,
  STOPPED: true,
  DELETED: true
};

export const AWSDeployStates = Object.keys(AWSDeployStatesBREAK);

export const AWS_ALL = {
  AWSDeployStatesBREAK,
  AWSDeployStates,
  AWSDeployStatesDetails
};

export const dateToday = new Date();
export const galaxyFarFarAway = new Date(dateToday.getFullYear() - 999, dateToday.getDay(), dateToday.getMonth());

export function uuidv4() {
  return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, (c) =>
    (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
  );
}

export const targetsData = [{
  id: "Z9c442348-df09-484f-b0a2-b31737450",
  name: "Amazon - dev env",
  createdAt: 1690578749173,
  icon: "img/aws.svg"
}, {
  id: "A8123348-d13384f-bwewe-b35437450",
  name: "Amazon - demo env",
  createdAt: 1691594749173,
  icon: "img/aws.svg",
  iconSize: 24
}, {
  id: "B32342-f6a334fg-b5s1-221345",
  name: "Google - QA env",
  createdAt: 1691594749173,
  icon: "img/gcp.svg"
}, {
  id: "C0129393-8asdjl-jjski-9ajwy5",
  name: "Azure - DEMO env",
  createdAt: 1691594749173,
  icon: "img/azu.svg"
}];

export function getApplicationImage(inName, inAppTempID, isDarkMode=true) {
  let name = `${inName}`;
  let appTempID = `${inAppTempID}`;

  if ( appTempID == "AppComponent") {
    if (name.toLowerCase().indexOf("github") >= 0) {
      return window.location.origin + '/img/svg/github.svg';
    } else if (name.toLowerCase().indexOf("gitlab") >= 0){
      return window.location.origin + '/img/svg/gitlab.svg';
    } else if (name.toLowerCase().indexOf("bitbucket") >= 0){
      return window.location.origin + '/img/svg/bitbucket.svg';
    } else if (name.toLowerCase().indexOf("servicenow") >= 0){
      return window.location.origin + '/img/svg/servicenow.svg';
    } else if (name.toLowerCase().indexOf("artifactory") >= 0){
      return window.location.origin + '/img/svg/jfrog.svg';
    }
  }

  if (appTempID== "aws") {
    return window.location.origin + '/img/aws.svg';
  } else if (appTempID== "azure") {
    return window.location.origin + '/img/azu.svg';
  } else if (appTempID== "gcp") {
    return window.location.origin + '/img/gcp.svg';
  } else if (appTempID.toLowerCase().startsWith("kubernetes")) {
    return k8sIcon;
  } else if (name.toLowerCase().indexOf("postgres") >= 0) {
    return window.location.origin + '/img/svg/postgres.svg';
  } else if (appTempID.toLowerCase().indexOf("iis::") >= 0) {
    return window.location.origin + '/img/svg/windows.svg';
  } else if (appTempID.toLowerCase().indexOf("tomcat") >= 0) {
    return window.location.origin + '/img/svg/tomcat.svg';
  } else if (appTempID.toLowerCase().indexOf("paperless") >= 0) {
    return window.location.origin + '/img/svg/paperless.svg';
  }else if (appTempID.toLowerCase().indexOf("django") >= 0) {
    return window.location.origin + '/img/svg/django.svg';
  } else if (appTempID.toLowerCase().indexOf("python") >= 0 || name.toLowerCase().indexOf("python") >=0 ) {
    return window.location.origin + '/img/svg/python.svg';
  } else if (appTempID.toLowerCase() == "activemq") {
    return window.location.origin + '/img/svg/activemq.svg';
  } else if (appTempID.toLowerCase() == "sql_server") {
    return window.location.origin + '/img/svg/mssqlserver.svg';
  } else if (appTempID.toLowerCase().indexOf("java") >= 0) {
    return window.location.origin + '/img/svg/java.svg';
  } else if (appTempID.toLowerCase() == "iis") {
    return window.location.origin + '/img/svg/windows.svg';
  } else if (appTempID.toLowerCase() == "ofbiz") {
    return window.location.origin + '/img/svg/ofbiz.svg';
  } else if (appTempID.toLowerCase().indexOf("jboss") >= 0) {
    return window.location.origin + '/img/svg/jboss.svg';
  } else if (appTempID.toLowerCase().indexOf("websphere") != -1) {
    return window.location.origin + '/img/svg/websphere.svg';
  } else if (appTempID.toLowerCase().indexOf("docker") != -1) {
    return window.location.origin + '/img/svg/docker.svg';
  } else if (appTempID.toLowerCase().indexOf("apache2") != -1) {
    if (name.toLowerCase().indexOf("drupal") != -1) {
      return window.location.origin + '/img/svg/drupal.svg';
    } else if (name.toLowerCase().indexOf("wordpress") != -1) {
      return window.location.origin + '/img/svg/wordpress.svg';
    }

    return window.location.origin + '/img/svg/apache2.svg';
  } else {
    if(isDarkMode){
      return window.location.origin + "/img/svg/app.svg";
    } else {
      return window.location.origin + "/img/svg/app-light.svg";
    }
  }
}

export const allAchorPoints = [
  //DOWN
  [0.5, 1],
  [0.1, 1], [0.2, 1], [0.3, 1], [0.4, 1],
  [0.6, 1], [0.7, 1], [0.8, 1], [0.9, 1],

  // RIGHT
  [1, 0.5],
  [1, 0.1], [1, 0.2], [1, 0.3], [1, 0.4],
  [1, 0.6], [1, 0.7], [1, 0.8], [1, 0.9],

  //LEFT - 
  [0, 0.5],
  [0, 0.1], [0, 0.2], [0, 0.3], [0, 0.4],
  [0, 0.6], [0, 0.7], [0, 0.8], [0, 0.9],

  //UP - 
  [0.5, 0],
  [0.1, 0], [0.2, 0], [0.3, 0], [0.4, 0],
  [0.6, 0], [0.7, 0], [0.8, 0], [0.9, 0]
];

const validIPV4 = new RegExp(/(([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])/);
const validIPV6 = new RegExp(/((([0-9a-fA-F]){1,4}):){7}([0-9a-fA-F]){1,4}/);
const validFQDN = new RegExp(/(?=^.{1,254}$)(^(((?!-)[a-zA-Z0-9-]{1,63}(?<!-))|((?!-)[a-zA-Z0-9-]{1,63}(?<!-)\.)+[a-zA-Z]{2,63})$)/);
export const isValidIP = (inIp) => {
  if (inIp.match(validIPV4)) {
    return true;
  } else if (inIp.match(validIPV6)) {
    return true;
  }

  return false;
}

export const isValidFQDN = (inFQDN) => {
  if (inFQDN && inFQDN.match(validFQDN)) {
    return true;
  }
  return false;
}

export const isValidIPList = (inIpList) => {
  let returnValue = true;

  for (let i = 0; i < inIpList.length; i++) {
    if (!isValidIP(inIpList[i])) {
      returnValue = false;

      break;
    }
  }

  return returnValue;
}

const isIPV6R = new RegExp(/(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))/);

export function isIPV6(ip) {
  return isIPV6R.test(ip);
}

const isPrivateIPR = new RegExp(/(^127\.)|(^192\.168\.)|(^10\.)|(^172\.1[6-9]\.)|(^172\.2[0-9]\.)|(^172\.3[0-1]\.)|(^::1$)|(^[fF][cCdD])/);

function checkIpAdress(ipAddress) { 
  try { 
      const parsed = new Address6(ipAddress); 

      if (parsed.is4 && parsed.address4.isCorrect) {
        return isPrivateIPR.test(parsed.address4.address);
      }

      return parsed.isValid(); 
  } catch (e) { 
      return false;
  } 
} 

export function isPrivateIP(ip) {
  if (ip.startsWith('::')) {
    return checkIpAdress(ip);
  }

  return isPrivateIPR.test(ip);
}

const __PREVENT_DUPLICATE = true;
const __ASSESS_AUTOHIDE_DURATION = 15000;
const __ANCHOR_ORIGIN = {
  vertical:"bottom",
  horizontal:"right"
};

export const errorOptions = {
  variant:"error",
  autoHideDuration: __ASSESS_AUTOHIDE_DURATION,
  preventDuplicate:__PREVENT_DUPLICATE,
  anchorOrigin:__ANCHOR_ORIGIN,
  action: (key) => (
    <Button onClick={() => closeSnackbar(key)}  style={{color:"#FEFEFE"}}>
      <CloseIcon />
    </Button>
  )
};

export const infoOptions = {
  variant:"info",
  autoHideDuration: __ASSESS_AUTOHIDE_DURATION,
  preventDuplicate:__PREVENT_DUPLICATE,
  anchorOrigin:__ANCHOR_ORIGIN,
  action: (key) => (
    <Button onClick={() => closeSnackbar(key)} style={{color:"#FEFEFE"}}>
      <CloseIcon />
    </Button>
  )
};

export function capitalize(a) {
  if (!a) {
    return "";
  }

  if (a.length == 1) {
    return a.toUpperCase();
  }

  return a.charAt(0).toUpperCase() + a.slice(1);
}

export function decamelize(str, separator) {
  separator = typeof separator === 'undefined' ? ' ' : separator;
  let out =
    `${str}`
      .replace(/([a-z\d])([A-Z])/g, '$1' + separator + '$2')
      .replace(/([A-Z]+)([A-Z][a-z\d]+)/g, '$1' + separator + '$2')
      .toLowerCase();

  if (out == str) {
    out = `${str}`.replaceAll("_", " ");
  }
  
  return out;
}

export function processIntrospection(aData) {
  try {
    window._g.intro = aData;
    window._g.appf = {};

    window._g.appf.app_schema = {
      raw: window._g.intro,
      byName: {},
      byNameTYPE: {}
    }

    try {
      window._g.intro.__schema.types.forEach(type => {
        if (type.kind == 'OBJECT') {

          window._g.appf.app_schema.byName[type.name] = [];
          window._g.appf.app_schema.byNameTYPE[type.name] = [];
          type.fields.forEach(el => {
            window._g.appf.app_schema.byName[type.name].push(el.name)
            try {
              if (el.type.kind == "OBJECT" ||
                el.type.ofType && el.type.ofType.kind == "OBJECT" ||
                el.type.ofType && el.type.ofType.ofType && el.type.ofType.ofType.kind == "OBJECT" ||
                el.type.ofType && el.type.ofType.ofType && el.type.ofType.ofType.ofType && el.type.ofType.ofType.ofType.kind == "OBJECT"
              ) {
                let val = el.type.name;
                if (val == null) {
                  val = el.type.ofType.name
                  if (val == null) {
                    val = el.type.ofType.ofType.name
                    if (val == null) {
                      val = el.type.ofType.ofType.ofType.name
                    }
                  }
                }
                window._g.appf.app_schema.byNameTYPE[type.name].push(`OBJECT-${val}`);
              }
              else
                if (el.type.kind == "LIST") {
                  window._g.appf.app_schema.byNameTYPE[type.name].push(`LIST-${el.type.ofType.ofType.name}`);
                } else
                  if (el.type.kind == "SCALAR") {
                    window._g.appf.app_schema.byNameTYPE[type.name].push(el.type.name);
                  } else {
                    if (el.type.ofType.name != null) {
                      window._g.appf.app_schema.byNameTYPE[type.name].push(el.type.ofType.name);
                    } else if (el.type.ofType.ofType.name != null) {
                      window._g.appf.app_schema.byNameTYPE[type.name].push(el.type.ofType.ofType.name);
                    } else if (el.type.ofType.ofType.ofType.name != null) {
                      window._g.appf.app_schema.byNameTYPE[type.name].push(el.type.ofType.ofType.ofType.name);
                    } else if (el.type.ofType.ofType.ofType.ofType.name != null) {
                      window._g.appf.app_schema.byNameTYPE[type.name].push(el.type.ofType.ofType.ofType.ofType.name);
                    }
                    else {
                      // console.log("... new attributes ... ")
                    }
                  }
            } catch (e) {
              // console.log("... new attributes 2... ")
            }
          });
        }

      });
    } catch (e) {
      // console.log(e)
    }
  } catch (e) {
    // console.log(e)
  }
}

let dictionary = {};


export const pSBC = (p, c0, c1, l) => {
  let cache = `${p}${c0}${c1}${l}`;

  if (Object.keys(dictionary).filter((it) => it === cache).length > 0) {
    return dictionary[cache]
  }

  let r, g, b, P, f, t, h, m = Math.round, a = typeof (c1) == "string";
  if (typeof (p) != "number" || p < -1 || p > 1 || typeof (c0) != "string" || (c0[0] != 'r' && c0[0] != '#') || (c1 && !a)) return null;
  h = c0.length > 9, h = a ? c1.length > 9 ? true : c1 == "c" ? !h : false : h, f = pSBC.pSBCr(c0), P = p < 0, t = c1 && c1 != "c" ? pSBC.pSBCr(c1) : P ? { r: 0, g: 0, b: 0, a: -1 } : { r: 255, g: 255, b: 255, a: -1 }, p = P ? p * -1 : p, P = 1 - p;
  if (!f || !t) return null;
  if (l) r = m(P * f.r + p * t.r), g = m(P * f.g + p * t.g), b = m(P * f.b + p * t.b);
  else r = m((P * f.r ** 2 + p * t.r ** 2) ** 0.5), g = m((P * f.g ** 2 + p * t.g ** 2) ** 0.5), b = m((P * f.b ** 2 + p * t.b ** 2) ** 0.5);
  a = f.a, t = t.a, f = a >= 0 || t >= 0, a = f ? a < 0 ? t : t < 0 ? a : a * P + t * p : 0;
  if (h) {
    dictionary[cache] = "rgb" + (f ? "a(" : "(") + r + "," + g + "," + b + (f ? "," + m(a * 1000) / 1000 : "") + ")"
    return dictionary[cache];
  }
  else {
    dictionary[cache] = "#" + (4294967296 + r * 16777216 + g * 65536 + b * 256 + (f ? m(a * 255) : 0)).toString(16).slice(1, f ? undefined : -2);
    return dictionary[cache];
  }
}

pSBC.pSBCr = (d) => {
  const i = parseInt;
  let n = d.length, x = {};
  if (n > 9) {
    const [r, g, b, a] = (d = d.split(','));
    n = d.length;
    if (n < 3 || n > 4) return null;
    x.r = i(r[3] == "a" ? r.slice(5) : r.slice(4)), x.g = i(g), x.b = i(b), x.a = a ? parseFloat(a) : -1
  } else {
    if (n == 8 || n == 6 || n < 4) return null;
    if (n < 6) d = "#" + d[1] + d[1] + d[2] + d[2] + d[3] + d[3] + (n > 4 ? d[4] + d[4] : "");
    d = i(d.slice(1), 16);
    if (n == 9 || n == 5) x.r = d >> 24 & 255, x.g = d >> 16 & 255, x.b = d >> 8 & 255, x.a = Math.round((d & 255) / 0.255) / 1000;
    else x.r = d >> 16, x.g = d >> 8 & 255, x.b = d & 255, x.a = -1
  } return x
};


const tagTransp = "0.41"
export const gData = {}

export function setVersionInfo(aData, machineId) {
  let returnVal = {};

  window._g.timeMachine = JSON.parse(JSON.stringify(aData.systems.map((data, a) => { return { version: data.version, id: data.id, timestamp: aData.hosts[a].timestamp , name: aData.hosts[a].name } })));
  window._g.timeMachineBID = {};
  window._g.timeMachine.forEach(t => {
    if (machineId && t.id == machineId) {
      returnVal = { v: t.version, t: t.timestamp };
    }

    window._g.timeMachineBID[t.id] = { v: t.version, t: t.timestamp };
  });

  return returnVal;
}

export function getSystemVersion(inMachineId) {
  return window._g.timeMachineBID[inMachineId]
}

export function cleanUpQuery(inQuery) {
  return inQuery;
}

const tagCOlorsOld = [
`rgba(199,40,40, ${tagTransp})`,
`rgba(173,23,87, ${tagTransp})`,
`rgba(154, 74, 34, ${tagTransp})`,
`rgba(160, 63, 44, ${tagTransp})`,
`rgba(37,57,147, ${tagTransp})`,
`rgba(37,57,147, ${tagTransp})`,
`rgba(0,131,143, ${tagTransp})`,
`rgba(0,105,92, ${tagTransp})`,
`rgba(86,138,48, ${tagTransp})`,
`rgba(250,166,37, ${tagTransp})`,
`rgba(255,142,0, ${tagTransp})`,
`rgba(239,107,0, ${tagTransp})`,
`rgba(217,66,20, ${tagTransp})`,
`rgba(78,52,46, ${tagTransp})`,
`rgba(66,66,66, ${tagTransp})`,
`rgba(55,71,79,${tagTransp})`
];

export function colorFromString(aString) {
  let hval = 0;
  let aIndex = "";

  for (let i = 0; i < aString.length; i++) {
    hval = aString.charCodeAt(i) + ((hval << 5) - hval);
  }

  // let newColor = '';

  for (let i = 0; i < 3; i++) {
    let value = (hval >> (i * 8)) & 0xFF;
    // newColor += ('00' + value.toString(16)).substr(-2);
    aIndex += value.toString(10)
  }
  // console.log((aIndex/(aIndex/tagCOlors.length)), newColor );
  return tagCOlorsOld[aIndex % tagCOlorsOld.length];

  // return `#${newColor}AA`;
}

export function scrollIntoView(e) {
  try {
    if (!e.target.classList.contains("MuiTableRow-root")) {
      let tar = e.target.parentNode;
      let tarLast = {};
      while (!tar.classList.contains("MuiTableRow-root")) {
        tarLast = tar;
        tar = tar.parentNode
      }
      let td = tarLast;
      td = tar.querySelector("td");
      // console.log(td.scrollTop,tar.scrollTop,tarLast.scrollTop);
      // console.log(tar,tarLast)
      // td.scrollIntoView(top);
      td.scrollIntoView({ behavior: "instant" });
      //   td.scrollTo({
      //     top: 10,
      //     left: 0,
      //     behavior: 'smooth'
      // });

    } else {
      e.target.scrollIntoView({ behavior: "instant" });
    }

  } catch (e) {
    // console.log(e)
  }
}
export const lHost = [
  "0.0.0.0",
  "::127.0.0.1",
  "::ffff:127.0.0.1",
  "127.0.0.1",
  "::1",
  "::::0",
  "fe80::1",
  "::",
  "*"
];

export const localhost = lHost;


export function communicationTransform(inCommsO, isApp) {
  let inComms = [];

  if (isApp) {
    inCommsO.forEach(appcom => {
      let aCom = {
        address: {
          ...appcom,
          localAddr: appcom.localIp,
          remoteAddr: appcom.remoteIp
        }
      }
      inComms.push(aCom)
    });
  } else {
    inComms = inCommsO
  }

  let locals = { "::": [] };
  let remotes = {};

  let listeningPorts = [];

  let states = [];
  let statesCount = {};

  for (let i = 0; i < inComms.length; i++) {
    let b = inComms[i];
    if (!states.includes(b.address.state)) {
      states.push(b.address.state);
      statesCount[b.address.state] = 0;
    }

    statesCount[b.address.state] = statesCount[b.address.state] + 1

    if (b.address.state == "Listen") {
      // console.log({addr:b.address.localPort,state:b.address.state,apid:b.associatedPids[0]  })
      listeningPorts.push({ addr: `${b.address.localAddr} ${b.address.localPort}`, state: b.address.state, apid: b.associatedPids[0] })
    }
  }
  // TODO:add listening ports to graph
  // console.log(statesCount)
  // console.log(listeningPorts)

  inComms.forEach(e => {

    if (lHost.includes(e.address.localAddr) || lHost.includes(e.address.remoteAddr)) {
      locals["::"].push(e)
    } else {
      if (typeof locals[e.address.localAddr] === 'undefined') {
        locals[e.address.localAddr] = []
      }

      locals[e.address.localAddr].push(e)
    }
  });
  let localAddrs = Object.keys(locals);
  
  inComms.forEach(e => {
    if (e.address.remoteAddr != null && e.address.remoteAddr !== "" && !lHost.includes(e.address.remoteAddr) && !localAddrs.includes(e.address.remoteAddr)) {
      if (typeof remotes[e.address.remoteAddr] === 'undefined') {
        remotes[e.address.remoteAddr] = []
      }
      remotes[e.address.remoteAddr].push(e)
    }
  });

  let pids = {}

  inComms.forEach(e => {
    if (e.associatedPids) {
      e.associatedPids.forEach(aPid => {
        if (typeof pids[aPid] === 'undefined') {
          pids[aPid] = []
        }
        pids[aPid].push(e)
      })
    }
  });

  return { locals, remotes, pids, listeningPorts };
}


export function findAncestor(el, cls) {
  if (el.classList.contains(cls)) {
    return el;
  }
  while ((el = el.parentElement) && !el.classList.contains(cls));
  return el;
}

export function formatBytes(bytes, decimals = 1) {
  if (!+bytes) return '0 Bytes'

  const k = 1024
  const dm = decimals < 0 ? 0 : decimals
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

  const i = Math.floor(Math.log(bytes) / Math.log(k))

  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
}
export const tenantInfoData = {}

export function processCurrentLocation(tenant) {
  // eslint-disable-next-line no-undef
  let currentLocation = window.location.host;

  // eslint-disable-next-line no-undef
  let isGoogle = `${process.env.REACT_APP_isGoogle}` == `true` || `${localStorage.isGoogle}` == `true`;
  let isLocalhost  = currentLocation.indexOf("localhost") !== -1
  
  if ( isLocalhost ) {
    if (isGoogle) {
      currentLocation = 'dev.appfactor.app'
    } else {
      currentLocation = 'dev.appfactor.cloud'
    }
  }

  let loc = currentLocation.split(".");

  if (isLocalhost && loc.length == 3) {
    if( tenant ){
      loc[0] = tenant
      if(isGoogle){
        loc[2] = "app"
      }else{
        loc[2] = "cloud"
      }
    }
  }else{
    try{
      let appTenantInfo = JSON.parse( localStorage.appf_tenant_info)
      if(appTenantInfo.api){
        return { currentLocation, envURL: appTenantInfo.api.replace("://api.", "://") };
      }else{
        loc = [`${currentLocation}`];
      }
    }catch(e){
      loc = [`${currentLocation}`];
    }
  }

  let envURL = "";
  try {
    // FIX: When running locally, use the current origin so requests like /tenant_info.json resolve correctly
    envURL = isLocalhost ? window.location.origin : window.location.protocol +"//" + loc.join(".");
  } catch (e) {
    console.log(e)
  }

  return { currentLocation, envURL };
}

export async function getTenantInfo(tenant) {
  let tenantResult = { poolId: "", clientId: "" };

  // eslint-disable-next-line no-undef
  let isGoogle = `${process.env.REACT_APP_isGoogle}` == `true` || `${localStorage.isGoogle}` == `true`;

  let dTinfo = {
    isFirebase: isGoogle,
    "tenant": tenant,
    "poolId": "eu-west-2_TpjF7jx55",
    "clientId": "55gf19fprt1vejhb1gt38mhl60"
  };

  try {
    const { envURL } = processCurrentLocation(tenant);

    let tenantData = {}
    try {
      tenantData = await fetch(`${envURL}/tenant_info.json?${new Date().getTime()}`);
      if (tenantData.ok) {
        tenantResult = await tenantData.json();
      } else {
        tenantResult = {}
      }

      if(typeof tenantResult.type !== 'undefined'){
        if(tenantResult.type == "firebase"){
          tenantResult.envURL = envURL;
          tenantResult.tenant = tenant;

          APPFACTOR.tenantInfo = {
            ...tenantResult,
            clientId:tenantResult.clientId,
            poolId:tenantResult.poolId
          };
          return tenantResult
        }
      }

    } catch (e) {/**/ }
    // console.log("getting tennant info" + envURL , tenantResult )

    if (typeof tenantResult.poolId === 'undefined') {
      tenantResult = dTinfo;
    }

    tenantResult.envURL = envURL;
    tenantResult.tenant = tenant;

  } catch (e) {
    tenantResult = dTinfo;
  }

  APPFACTOR.tenantInfo = {
    ...tenantResult,
    clientId:tenantResult.clientId,
    poolId:tenantResult.poolId
  };

  return  APPFACTOR.tenantInfo;
}

export const apolloError =  onError(({ networkError,...rest}) => {
  try {
    poolData.refreshToken();

    if(window.extendedLog){ exLog("T4", {networkError,...rest} , poolData.accessToken );}

    if (networkError?.statusCode === 401 ) {
      // window.location.reload()
      console.log("[3] - Reloading ... ")
      
    }
    const { response } = rest.operation.getContext();
    const { headers, status } = response;

    console.log(response,headers,status)
    
  } catch (e) {/**/ }

  try {
    if ( networkError.message=="Load failed" && typeof rest.graphQLErrors == "undefined") {
      console.log("[4] - Reloading ... ")
      // window.location.reload()
    }
  } catch (e) {/**/ }

  try {
    if ( networkError.message === "Failed to fetch"){
        try{
          poolData.refreshToken();
        }catch(e){/**/}

        try {
          if (appf_tenant_info.azureRefreshToken) {
            appf_tenant_info.azureRefreshToken();
          }
        } catch (e) { /* */ }
    }
  } catch (e) { /* */ }
});

export const getDeployTargets = async (url, token) => {
  let retVal = {};

  try {
    retVal = await fetch(`${url}/deploy/targets`, {
      headers: {
        authorization: token ? `Bearer ${token}` : '',
      }
    });
  } catch (e) {/**/ }
  return retVal;
}

const mock = 0

export function getApiUrl(envURL) {
  if (mock == 1)
    return "http://localhost:3033"

  if( appf_tenant_info.api && appf_tenant_info.api.length>0 ){
    return appf_tenant_info.api
  }

  if( typeof envURL === "undefined" || envURL == null || envURL == "" ){
    return `${window.location.protocol}//api.${window.location.hostname}`
  }

  return `${envURL.replace("://", "://api.")}`
}

export function getGraphqlUrl(envURL) {
  // Prefer dev/test environments to use a relative path so Vite dev proxy or Jest can handle it
  try {
    const isDev = typeof process !== 'undefined' && process?.env && (process.env.NODE_ENV === 'development' || !!process.env.JEST_WORKER_ID);
    if (isDev) {
      return '/graphql';
    }
  } catch (e) { /* noop */ }

  // Fallback to hostname check (e.g., localhost)
  try {
    const host = window?.location?.hostname || '';
    if (host === 'localhost' || host === '127.0.0.1') {
      return '/graphql';
    }
  } catch (e) { /* noop */ }

  if (!envURL) {
    const { envURL: computedEnv } = processCurrentLocation(APPFACTOR.tenantInfo.tenant);
    return `${getApiUrl(computedEnv)}/graphql`;
  } else {
    return `${getApiUrl(envURL)}/graphql`;
  }
}

export const c_Fn = {
  cleanUpQuery,
  setVersionInfo,
  getSystemVersion
}

export const tableLocalization = {
  expand: 'Expand',
  expandAll: ' ',
  actions: (""),
  rowsPerPage: ("Rows/page")
}

export function formatTimestamp(timestamp) {
  let ts = `${timestamp ? new Intl.DateTimeFormat('en-US',
    {
      year: '2-digit', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit',
      hourCycle: 'h23'
    }).format(
      parseInt(timestamp, 10)
    ) : ""
    }`

  return ts;
}

export function gFilterFN (row, id, filterValue) {
  let res = false;

  try{
    if( id == "timestamp" ) {
      try{
        // console.log(row.original.timestamp,formatTimestamp(row.original.timestamp),filterValue)
        res = formatTimestamp(row.original.timestamp).indexOf(filterValue.toLowerCase()) !=-1
        return res;
      }catch(e){/**/}
    }else if( id == "totalCVE" ) {
      try{
        res = JSON.stringify(row.original).toString().toLowerCase().indexOf(filterValue.toLowerCase()) != -1
        return res;
      }catch(e){/**/}
    }
    else{
      res = ( row.getValue(id).toString().toLowerCase().indexOf(filterValue.toLowerCase()) != -1 );
    }
  }catch(e){/**/}

  return res;
}

export function activateMenu(name) {
  try {
      document.querySelectorAll(".wrapper1 .left-side a").forEach(e => e.classList.remove('active'))
      let el = document.querySelector(`a[data-val*="${name}"]`) ;
      el.classList.add("active");
  } catch (e) {/**/}
}

export const appFactorColors = {
  scheme: 'AppFactor',
  author: 'AppFactor',
  base00: '#2b303b',
  base01: '#343d46',
  base02: '#4f5b66',
  base03: '#65737e',
  base04: '#a7adba',
  base05: '#c0c5ce',
  base06: '#dfe1e8',
  base07: '#eff1f5',
  base08: '#bf616a',
  base09: '#d08770',
  base0A: '#ebcb8b',
  base0B: '#a3be8c',
  base0C: '#96b5b4',
  base0D: '#8fa1b3',
  base0E: '#b48ead',
  base0F: '#ab7967'
};

export const theColors = [
  0xde5e56,
  0xda4f7a,
  0x9f50b6,
  0x785bbc,
  0x5ca5ef,
  0x5ec4d7,
  0xa6ca72,
  0xf7cb50,
  0x0f0b8c,
  0x0C00F7,
  0x4f0839,
  0x980052
];

export function newSessionUID() {
  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, a => (a ^ Math.random() * 16 >> a / 4).toString(16));
}

export function checkUpdateNeeded(name, callUpdate) {
  if (localStorage.needUpdate) {
    try {
      let needUpdate = JSON.parse(localStorage.needUpdate);

      if(`${needUpdate[name]}` == "true") {
        needUpdate[name] = false;

        if (Object.keys(needUpdate).every(n=> needUpdate[n] == false)) {
          localStorage.needUpdate = "{}";
        } else {
          localStorage.needUpdate = JSON.stringify(needUpdate);
        }
        
        callUpdate();
      }
    } catch (e) { /* */ }
  }
}

const dFormat = {
  year: 'numeric', 
  month: '2-digit',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit'
};

function getDateTimeNice(date){
  return (new Intl.DateTimeFormat('en-US', dFormat).format(parseInt(date, 10)));
}

export function exLog(m, t, a) {
  "use strict";

  try {
    try {
      if (t.calle) {
        console.log(t.calle);
      }
    } catch (e) { /* */ }  

    let jwt = jwtDecode(a);

    console.log(`[[${m}]]`, {
      "_Expire":getDateTimeNice(jwt.exp*1000),
      "_IssuedAt":getDateTimeNice(jwt.iat*1000),
      "_Created":jwt?.auth_time?getDateTimeNice(jwt?.auth_time*1000):"--",
      t,accessToken:a,jwt})
    }catch(e){
      console.log(`[[${m}]] Invalid Token `,a,e )
    }
}

export function parseIana(inIanaDef) {
  let data = {};

  for (let i = 0; i < inIanaDef.length; i++) {
    data[inIanaDef[i].port] = inIanaDef[i];
  }

  window._g.ianaDef = {
    data,
    keys: Object.keys(data)
  };

  delete window.__iana;

  return window._g.ianaDef;
}


// IndexedDB utility for storing key-value pairs (key: string, value: JSON)
const DB_NAME = 'appFactor';
const DB_VERSION = 1;
const STORE_NAME = 'data';

function openIndexedDB() {
    return new Promise((resolve, reject) => {
        const request = indexedDB.open(DB_NAME, DB_VERSION);
        request.onupgradeneeded = function(event) {
            const db = event.target.result;
            if (!db.objectStoreNames.contains(STORE_NAME)) {
                db.createObjectStore(STORE_NAME);
            }
        };
        request.onsuccess = function(event) {
            resolve(event.target.result);
        };
        request.onerror = function(event) {
            reject(event.target.error);
        };
    });
}

export function getProjectKey(baseKey) {
  const projectId = window.currentProjectId || window.localStorage.lastProjectId || 'default';
  return `${baseKey}--${projectId}`;
}

export async function setItemDB(key, value) {
    const db = await openIndexedDB();
    return new Promise((resolve, reject) => {
        const tx = db.transaction(STORE_NAME, 'readwrite');
        const store = tx.objectStore(STORE_NAME);
        const req = store.put(JSON.stringify(value), key);
        req.onsuccess = () => {
            // Dispatch custom event when IndexedDB is updated
            window.dispatchEvent(new CustomEvent('indexedDBUpdated', {
                detail: { key, value }
            }));
            resolve(true);
        };
        req.onerror = (e) => reject(e);
    });
}

export async function getItemDB(key) {
    const db = await openIndexedDB();
    let res = {}
    await new Promise((resolve, reject) => {
        const tx = db.transaction(STORE_NAME, 'readonly');
        const store = tx.objectStore(STORE_NAME);
        const req = store.get(key);
        req.onsuccess = () => {
            try {
                res = JSON.parse(req.result) ;

                resolve(req.result ? JSON.parse(req.result) : null);
            } catch (e) {
                resolve(null);
            }
        };
        req.onerror = (e) => reject(e);
    })

    return res;
}

export async function removeItemFromDB(key) {
    const db = await openIndexedDB();
    return new Promise((resolve, reject) => {
        const tx = db.transaction(STORE_NAME, 'readwrite');
        const store = tx.objectStore(STORE_NAME);
        const req = store.delete(key);
        req.onsuccess = () => resolve(true);
        req.onerror = (e) => reject(e);
    });
}

/**
 * Compress arbitrary JS data to a gzip base64 string for IndexedDB storage.
 * Compatible with setItemDB (which JSON.stringifies its value).
 */
export async function compressToIDB(data) {
  const stream = new Blob([JSON.stringify(data)])
    .stream()
    .pipeThrough(new CompressionStream('gzip'));
  const buf = await new Response(stream).arrayBuffer();
  const bytes = new Uint8Array(buf);
  let binary = '';
  const chunkSize = 8192;
  for (let i = 0; i < bytes.length; i += chunkSize) {
    binary += String.fromCharCode(...bytes.subarray(i, i + chunkSize));
  }
  return btoa(binary);
}

/**
 * Decompress a gzip base64 string (written by compressToIDB) back to JS data.
 */
export async function decompressFromIDB(base64) {
  const binary = atob(base64);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
  const stream = new Blob([bytes]).stream().pipeThrough(new DecompressionStream('gzip'));
  return JSON.parse(await new Response(stream).text());
}

export const sxTopToolbarProps = {
  sx: {
    "& .MuiTablePagination-root": {
      display: "flex !important",
      flex: "111 !important",
      justifyContent: "center !important",
      minWidth: "calc(100% - 20px) !important",
      margin: 0,
    },
    border: "unset",
    background: "transparent",
    backgroundImage: "none",
    "& .MuiTablePagination-spacer": {
      display: "none"
    }
  }
}


export const INSTALLED_SOFTWARE_CACHE_KEY = "allInstalledSoftwareLocal";
export const DEBUG_LEVEL_VAL = "orchestratorDebugLevel";